import { Injectable } from '@angular/core';
import { RequestUniqueLink, ResponseUniqueLink } from '../models/userData.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from "@angular/router";
import { PayvalidaFeatureFlagService } from './payvalida-feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class UniqueLinkService {

  constructor(
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute,
    private readonly ffPayvalidaService: PayvalidaFeatureFlagService
  ) {
  }

  private merchantId: string;
  private token: string;

  flag = 'RmvMassiveUseLinkNameFielFF';
  platform = 'payvalida';

  getUniqueLink(request: RequestUniqueLink): Observable<ResponseUniqueLink> {

    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': request.token,
      })
    };
    return this.http.post<ResponseUniqueLink>(`${environment.urlglobal_api}/multilink/getUniqueLink`,
      request, headers).pipe(map((res) => res));
  }

  getMerchantIdQueryParam() {
    if (!this.merchantId) {
      this.merchantId = this.route.snapshot.queryParamMap.get('merchantId');
    }
    return this.merchantId;
  }

  getTokenQueryParam() {
    if (!this.token) {
      this.token = this.route.snapshot.queryParamMap.get('token');
    }
    return this.token;
  }

  getFeatureFlagValue(merchantName: string) {
    return new Promise((resolve, reject) => {
      this.ffPayvalidaService.getFeatureFlagValue(merchantName, this.flag, this.platform).subscribe({
        next: (value) => {
          resolve(value);
        }, error: (_) => {
          reject();
        }
      });
    });
  }
}
